import React, { Component } from "react";
import ContactForm from "./ContactForm";
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';

class ContactTwo extends Component {
    static contextType = LanguageContext;

    render(){
        const { language } = this.context;
        const t = translations[language];

        return(
            <div className="contact-form--1">
                <div className="container">
                    <div className="row row--35 align-items-start">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--50">
                                <h2 className="title">{t.contact.form.title}</h2>
                                <p className="description">{t.contact.form.description}</p>
                            </div>
                            <div className="form-wrapper">
                                <ContactForm />
                            </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src="/assets/images/about/about-6.jpg" alt="trydo"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactTwo;